export const PAGE_TYPES = {
  FORM: 'form',
  DASHBOARD: 'dashboard',
};
export const FORM_LAYOUTS = {
  SINGLE_COLUMN: 'single column',
  TWO_COLUMNS: 'two columns',
};
